import React, { useState, useEffect } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import './CheckoutForm.css';
import { EVO } from '../EVO';
import { Loader } from './Loader';
import { SubmitButton } from './SubmitButton';
import { history } from './../configureStore';
import { urls } from '../urls';
import { PTInputText } from './PTElements';
import { useDispatch } from 'react-redux';
import { updateModel } from "../redux/ensure";

const CheckoutForm = props => {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(true);
    const [secret, setSecret] = useState('');
    const [paying, setPaying] = useState(false);
    const id = props.id;
    const [paymentId, setPaymentId] = useState('');
    const dispatch = useDispatch();
    const [billingDetails, setBillingDetails] = useState({
        name: '',
        address: ''
    });

    useEffect(() => {
        if (!id) {
            EVO.error("Couldn't find id")
        }
        else {
            EVO.post('/api/stripe', {
                productId: id
            }).then(function (responseJson) {
                if (responseJson.secret) {
                    setSecret(responseJson.secret);
                    setPaymentId(responseJson.paymentId);
                    setLoading(false);
                }
                else {
                    EVO.error('Error retrieving Stripe');
                }
            });
        }
    }, [id]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        setPaying(true);

        const cardElement = elements.getElement(CardElement);
        const result = await stripe.confirmCardPayment(secret, {
            payment_method: {
                card: cardElement,
                type: 'card',
                billing_details: billingDetails,
            }
        });

        if (result.error) {
            EVO.error(result.error.message);
            setPaying(false);
        }
        else {
            if (result.paymentIntent.status === 'succeeded') {
                result.paymentIntent.productId = id;
                result.paymentIntent.paymentId = paymentId;
                EVO.put('/api/stripe', result.paymentIntent, {
                    displayToastOnError: false
                }).then(r => {
                    setPaying(false);
                    dispatch(updateModel({
                        smsCredit: r.smsCredit
                    }));
                    EVO.success('Your payment was successful. A receipt has been emailed to you');
                    history.push(urls.router.notificationchores.index.url);
                }).catch(e => {
                    setPaying(false);
                    EVO.error(e);
                });
            }
        }
    };

    return (
        <Loader loading={loading}>
            <form onSubmit={handleSubmit} className="checkout-form">
                <PTInputText
                    field={{
                        name: 'name',
                        value: billingDetails.name,
                        onChange: (e) => {
                            setBillingDetails({ ...billingDetails, name: e.target.value });
                        }
                    }}
                    required
                    form={{}}
                    placeholder="Cardholder Name"
                    left full
                />
                <CardElement options={CARD_OPTIONS} hidePostalCode={true} />
                <SubmitButton type="submit" disabled={!paying && !stripe} classNames={{ 'loading': paying }} text="Pay" />
            </form>
        </Loader>
    );
};

const CARD_OPTIONS = {
    iconStyle: 'solid',
    style: {
        base: {
            fontWeight: 500,
            fontSize: '16px',
        },
    },
};

export default CheckoutForm;


// WEBPACK FOOTER //
// ./src/components/CheckoutForm.js